//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { IScope } from 'angular';
import React from 'react';
import { ActionButton } from 'unison';

import makeAngularReactControllerWithScope, {
  applyScope,
} from '@react-bridge/angular-react-widget-with-scope';

interface Props {
  isDisabled: boolean;
  onClick: () => void;
}

const BeautifyActionButton = ({ isDisabled, onClick }: Props) => {
  return (
    <ActionButton
      iconName='beautify'
      isDisabled={isDisabled}
      label='Beautify'
      onClick={onClick}
    />
  );
};

angular.module('curalate').component('beautifyActionButton', {
  bindings: {
    isDisabled: '<',
    onClick: '&',
  },
  controller: makeAngularReactControllerWithScope(
    (scope: { $ctrl: Props } & IScope) => {
      return (
        <div>
          <BeautifyActionButton
            isDisabled={scope.$ctrl.isDisabled}
            onClick={applyScope(scope, scope.$ctrl.onClick)}
          />
        </div>
      );
    },
  ),
});
